import React, { useState, useMemo } from 'react';
import ZoomModal from '../../../../DeviationViews/Full/Image/ZoomModal';
import Img from './ImageBase';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import cleanLinkSrc from '../../../../utils/xss/cleanLinkSrc';
const ImgZoomable = (props)=>{
    const [showFullview, setShowFullview] = useState(false);
    const { file, deviation, imgStyles } = props;
    const fullview = useMemo(()=>DeviationMediaService.getLargestFullview(deviation), [
        deviation
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        onClick: ()=>{
            setShowFullview(true);
        },
        style: {
            cursor: 'zoom-in',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Img, {
        file: file,
        deviation: deviation,
        imgStyles: imgStyles
    })), showFullview && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: cleanLinkSrc(fullview.src),
        srcSet: fullview.srcSet,
        width: fullview.width,
        height: fullview.height,
        isPixel: false,
        onClose: ()=>{
            setShowFullview(false);
        }
    }));
};
ImgZoomable.displayName = 'ImgZoomable';
export default ImgZoomable;

//# sourceMappingURL=ImageZoomable.js.map